

export const PayBtn = ({props, onHandleClick}) => {

    const {payment, orderId, paid} = props;

    return (
        <tr style={{borderBottom: 'none', borderColor: 'white'}}>
            <td colSpan={3} className='text-center'>
                <div className="accordion accordion-flush" id="pay-methods">
                    <div className="accordion-item">
                        {paid && Number(paid) === 2 
                            ?
                                <h2 className="accordion-header">
                                    <button className="btn w-100 collapsed text-center" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                                        Оплачено
                                    </button>
                                </h2>
                            :
                            <>
                                <h2 className="accordion-header">
                                    <button className="btn w-100 collapsed text-center" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                                        Онлайн оплата
                                    </button>
                                </h2>
                                <div id="flush-collapseOne" className="accordion-collapse collapse" data-bs-parent="#pay-methods">
                                    <div className="accordion-body p-0 py-1">
                                        {Object.entries(payment).map(([method, values], index) => {
                                            if (method !== "cash" && method !== "card"){

                                                let methodName = values.name.split(' ').slice(1).join(' ');
                                                methodName = methodName.charAt(0).toUpperCase() + methodName.slice(1)

                                                return (
                                                    <button key={index} onClick={() => onHandleClick({method, orderId})} className='btn w-100'>{methodName}</button>
                                                )
                                            }
                                        })}
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                </div>
            </td>
        </tr>
    )
}